import Svg, { Path } from 'react-native-svg'

export const CalculatorIcon = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M17 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3ZM8 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM8 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1Z"
      />
    </Svg>
  )
}
